export default {"src":"/_next/static/media/locationpin.aee577e8.svg","height":19,"width":14,"blurWidth":0,"blurHeight":0};